import settings from '/@/core/settings';
import { getProductDatasheetBrand } from '/@/store/product-datasheet/selectors';
import { getAppInstance, getSessionLanguage } from '/@/store/session/selectors';
import { createAction } from '/@/store/utils';
import { axFetch } from '../../session/actions';

const getProductDatasheetPayload = (state, productDatasheet, productDatasheetConfigs) => {
    return {
        ...productDatasheet,
        brand: getProductDatasheetBrand(state, productDatasheet, productDatasheetConfigs),
    };
};

export const downloadProductDatasheetPDF = createAction(
    'PRODUCT_DATASHEET_PDFS:DOWNLOAD',
    async ({ payload, getState }) => {
        const state = getState();
        const response = await axFetch.post(settings.urls.productDatasheet.link, {
            async: payload.download ? 'false' : 'true',
            appInstance: getAppInstance(state).id,
            language: getSessionLanguage(state),
            payload: getProductDatasheetPayload(state, payload.productDatasheet, payload.productDatasheetConfigs),
        });

        return response.data;
    }
);

export const emailProductDatasheetPDF = createAction('PRODUCT_DATASHEET_PDFS:EMAIL', async ({ payload, getState }) => {
    const state = getState();

    const response = await axFetch.post(settings.urls.productDatasheet.link, {
        payload: getProductDatasheetPayload(state, payload.productDatasheet, payload.productDatasheetConfigs),
        recipient: payload.email,
        appInstance: getAppInstance(state).id,
        language: getSessionLanguage(state),
    });

    if (response.status === 200) {
        return response.data;
    }
    throw Error();
});
